<template>
  <layout-auth style="background: #f3f5f7 !important">
    <v-container class="py-10">
      <v-row>
        <v-col cols="12">
          <h1 class="text-h4 font-weight-light py-5">
            {{
              isSimulation
                ? $t("invoices.simulacionLiquidacion")
                : $t("invoices.ResumenYconfirmacion")
            }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3 class="source-sans-pro-ligh">
            {{ $t("invoices.datosAnticipos") }}
          </h3>

          <p>
            {{ $t("invoices.DetallesSimulacion22") }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3 class="beneficiario">
            {{ $t("invoices.nombrePagador") }}
          </h3>

          <p class="maria-laura-rivas-pa">
            {{ client }}
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col style="margin: 10px !important">
          <h3 class="source-sans-pro-ligh">
            {{ $t("invoices.detallesFacturas") }}
          </h3>
        </v-col>
        <v-col md="2" style="margin: 10px !important" v-if="isSimulation">
        </v-col>
        <v-col
          xs="12"
          sm="12"
          md="3"
          lg="2"
          style="margin: 10px !important"
          v-if="isSimulation"
        >
          <span class="fecha-valor">{{ $t("invoices.dateValue") }}</span>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :rules="[rules.required]"
                readonly
                outlined
                dense
                placeholder="DD/MM/YYYY"
                v-model="dateFormatted"
                :color="entityConfig.primaryColor"
                persistent-hint
                append-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :color="entityConfig.primaryColor"
              v-model="date"
              no-title
              :locale="$i18n.locale"
              :max="maxDate"
              :min="minDate"
              @input="menu1 = false"
              @change="callSimulation()"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-container>
        <v-divider :color="entityConfig.primaryColor"></v-divider>
        <error-table :erroCode="valCode" :hidden="!noData" />
        <v-data-table
          :hidden="noData"
          class="tabla-anticipos firt-col-right-margin"
          fixed-header
          disable-pagination
          no-data-text="No hay datos que mostrar"
          style="background: #f3f5f7 !important"
          :headers="headers"
          :items="simulacionLiquidacion"
          hide-default-footer
        >
          <template v-slot:item.numInvoiceExt="{ item }">
            <strong>{{ item.numInvoiceExt }}</strong>
          </template>

          <template v-slot:item.nominalAmount="{ item }">
            {{ dataFormatter.currencyFormatter(item.nominalAmount) }}
          </template>

          <template v-slot:item.percentageInterest="{ item }">
            {{ dataFormatter.numberFormatter(item.percentageInterest) }}
          </template>

          <template v-slot:item.interest="{ item }">
            {{ dataFormatter.numberFormatter(item.interest) }}
          </template>

          <template v-slot:item.commission="{ item }">
            {{ dataFormatter.numberFormatter(item.commission) }}
          </template>

          <template v-slot:item.tax="{ item }">
            {{ dataFormatter.numberFormatter(item.tax) }}
          </template>

          <template v-slot:item.spending="{ item }">
            {{ dataFormatter.numberFormatter(item.spending) }}
          </template>

          <template v-slot:item.spendingCharged="{ item }">
            {{ dataFormatter.numberFormatter(item.spendingCharged) }}
          </template>

          <template v-slot:item.total="{ item }">
            {{ dataFormatter.numberFormatter(item.total) }}
          </template>
        </v-data-table>
      </v-container>
      <v-row>
        <v-col cols="">
          <v-container>
            <span class="beneficiario py-5 float-end" v-if="isSimulation">
              {{ $t("invoices.totalLiquidation") }}
              <strong>{{
                dataFormatter.currencyFormatter(totalLiquidacion)
              }}</strong>
            </span>
          </v-container>
        </v-col>
      </v-row>

      <v-container>
        <v-row>
          <v-col cols="12">
            <v-row style="margin: 0px !important">
              <h1 class="resumen">
                {{ $t("invoices.Resumen") }}
              </h1>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-10" cols="12" sm="4" md="3">
            <v-row>
              <label class="second-type-label">
                {{ $t("invoices.cuentaAbono") }}
              </label>
            </v-row>
            <v-row>
              <p>{{ dataFormatter.accountNumberFormatter(iban) }}</p>
            </v-row>
          </v-col>
          <v-col class="py-10" cols="6" sm="4" md="3">
            <v-row>
              <label class="second-type-label"
                >{{ $t("invoices.fechaSolicitud") }}
              </label>
            </v-row>
            <v-row>
              <p>{{ dateWithFormat }}</p>
            </v-row>
          </v-col>
          <v-col class="py-10" cols="6" sm="4" md="3">
            <v-row>
              <label class="second-type-label"
                >{{ $t("invoices.numeroFactura") }}
              </label>
            </v-row>
            <v-row>
              <p>{{ invoiceCount }}</p>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-10" cols="6" sm="4" md="3">
            <v-row>
              <label class="second-type-label">
                {{ $t("invoices.importeTotalFinnciar") }}
              </label>
            </v-row>
            <v-row>
              <p>{{ dataFormatter.currencyFormatter(totalFinanciacion) }}</p>
            </v-row>
          </v-col>
          <v-col class="py-10" cols="6" sm="4" md="3">
            <v-row>
              <label class="second-type-label"
                >{{ $t("invoices.TotalLiquidación") }}
              </label>
            </v-row>
            <v-row>
              <p>{{ dataFormatter.currencyFormatter(totalLiquidacion) }}</p>
            </v-row>
          </v-col>
        </v-row>

        <v-row
          style="color: #6a6f78; font-size: 0.9em"
          class="py-4"
          v-if="isSimulation"
        >
          <p>  {{ $t("invoices.simulationMsj") }}</p>
        </v-row>

        <v-row>
          <checkbox-terms :checkboxData="entityConfig.checkboxAnticipoFacturas" @accepted="checkbox = true" @canceled="checkbox = false" />
        </v-row>
      </v-container>

      <v-row>
        <v-col cols="12" sm="12" lg="12">
          <span v-if="isCurrentDate">
            <v-btn
              v-if="!confirmed"
              @click="confirmSimulation"
              :disabled="!checkbox"
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("invoices.requestAdvance") }}
            </v-btn>
            <v-btn
              v-else
              @click="finalizar"
              :disabled="!checkbox"
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.finish") }}
            </v-btn>
          </span>
          <v-btn
            v-if="!confirmed"
            outlined
            :disabled="confirmed"
            @click="volver"
            :color="entityConfig.primaryColor"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("supplierData.goBack") }}
          </v-btn>
          <v-btn
            v-else
            plain
            :disabled="!confirmed"
            :color="entityConfig.primaryColor"
            @click="print"
            class="float-end m-2"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("supplierData.print") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <overlay :visible="spinner" :opacity="1"></overlay>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import dataFormatter from "../../plugins/dataFormatter";
import Api from "../../Services/index";
import CheckboxTerms from "../../components/layouts/checkbox-terms.vue";
import ErrorTable from "../../components/layouts/error-table.vue";
import { createToastInterface } from "vue-toastification";

export default {
  components: {
    "layout-auth": LayoutAuth,
    "checkbox-terms": CheckboxTerms,
    Overlay,
    ErrorTable,
  },
  data: (vm) => ({
    noData: false,
    valCode: 0,
    spinner: false,
    checkbox: false,
    isSimulation: false,
    confirmed: false,
    dataFormatter: dataFormatter,
    simulationModel: {
      cuentasDeAbono: "",
      selectedInvoices: [],
    },
    date: "",
    today: "",
    entityConfig: {},
    simulationForm: {
      invoiceSimulationDtoList: [],
      numClient: "",
      simulationDate: "",
    },
    dateFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    menu1: false,
    headers: [
      {
        text: "Nº DE FACTURA",
        sortable: false,
        value: "numInvoiceExt",
      },
      {
        text: "IMP. A FINANCIAR",
        sortable: false,
        value: "nominalAmount",
        align: "right",
      },
      {
        text: "% INTERÉS",
        sortable: false,
        value: "percentageInterest",
        align: "right",
      },
      {
        text: "DÍAS INTERESES",
        sortable: false,
        value: "interestDays",
        align: "right",
      },
      {
        text: "INTERÉS",
        sortable: false,
        value: "interest",
        align: "right",
      },
      {
        text: "COMISIÓN",
        sortable: false,
        value: "commission",
        align: "right",
      },
      {
        text: "IMPUESTOS",
        sortable: false,
        value: "tax",
        align: "right",
      },
      {
        text: "GASTOS",
        sortable: false,
        value: "spending",
        align: "right",
      },
      {
        text: "IMP. COB. GTOS",
        sortable: false,
        value: "spendingCharged",
        align: "right",
      },
      {
        text: "TOTAL LIQ.",
        sortable: false,
        value: "total",
        align: "right",
      },
    ],
    simulacionLiquidacion: [{ total: 0, nominalAmount: 0 }],

    rules: {
      required: (value) => !!value || "Este campo es requerido..",
    },
  }),

  mounted() {
    this.simulationModel = JSON.parse(
      sessionStorage.getItem("simulationModel")
    );
    this.today = this.dateFormatted;
    this.entityConfig = this.$store.state.entityConfig.config;
    this.isSimulation = /true/i.test(this.$route.query.isSimulation);
    if (this.simulationModel) {
      Api.defaults.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("authtoken");
      this.simulationForm.numClient = this.simulationModel.client.numCliente;
      this.simulationForm.invoiceSimulationDtoList =
        this.simulationModel.selectedInvoices.map((x) => ({
          nominalAmount: x.newNominalAmountFinanced,
          numInvoice: x.invoiceNumber,
          numInvoiceExt: x.invoiceNumberExt,
        }));
      this.requestSimulation();
    } else {
      this.$router.go(-1);
    }
  },
  computed: {
    maxDate() {
      const dateFechaMax = new Date();
      dateFechaMax.setDate(dateFechaMax.getDate() + 365);
      return dateFechaMax.toISOString().substr(0, 10);
    },
    minDate() {
      const dateFechaMin = new Date();
      dateFechaMin.setDate(dateFechaMin.getDate());
      return dateFechaMin.toISOString().substr(0, 10);
    },
    dateWithFormat() {
      let [d, m, y] = this.dateFormatted.split("/");
      let date = `${y}-${m}-${d}`;
      return this.dataFormatter.dateFormatter(date, this.$i18n.locale);
    },
    isCurrentDate: function () {
      return this.today === this.dateFormatted;
    },
    client: function () {
      return this.simulationModel.client?.name;
    },
    iban: function () {
      return this.simulationModel.iban;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    totalLiquidacion: function () {
      return this.simulacionLiquidacion.reduce((x, y) => x + y.total, 0);
    },
    totalFinanciacion: function () {
      let total = this.simulacionLiquidacion.reduce((x, y) => x + y.nominalAmount, 0);
      return parseFloat(total.toFixed(2));
    },
    invoiceCount: function () {
      return this.simulationModel.selectedInvoices.length;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    callSimulation() {
      let that = this;
      setTimeout(function () {
        that.requestSimulation();
      }, 100);
      this.checkbox = false;
    },
    print() {
      window.print();
    },
    requestSimulation() {
      this.simulacionLiquidacion = [];
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let idProveedor = userdata.supplierId.trim();
      this.spinner = true;
      let [d, m, y] = this.dateFormatted.split("/");
      this.simulationForm.simulationDate = `${y}-${m}-${d}`;
      Api.post(
        `/proveedores/${idProveedor}/simulacion-financiacion`,
        this.simulationForm
      )
        .then((resp) => {
          this.simulacionLiquidacion = resp.data.response;
          this.noData = false;
        })
        .catch((error) => {
          this.valCode = error.response.data.code;
          this.noData = true;
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    confirmSimulation() {
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let formAnticitpo = JSON.parse(sessionStorage.getItem("formAnticitpo"));
      let idProveedor = userdata.supplierId.trim();
      this.spinner = true;
      let [d, m, y] = this.dateFormatted.split("/");
      let date = `${y}-${m}-${d}`;
      let requestFinanciacion = {
        applicationDate: date,
        iban: this.iban,
        invoiceAdvanceList: this.simulationModel.selectedInvoices.map((x) => {
          return {
            invoiceDate: x.invoiceExpirationDate,
            nominalAmount: x.newNominalAmountFinanced,
            numInvoice: x.invoiceNumber.toString(),
            numInvoiceExt: x.invoiceNumberExt,
            numSecuence: 1,
          };
        }),
        numClient: this.simulationModel.client.numCliente.toString(),
        totalAmount: this.totalFinanciacion,
        totalInvoice: this.invoiceCount,
        typeConfirming: formAnticitpo.tipoConfirming,
      };

      Api.post(
        `/proveedores/${idProveedor}/financiacion-factura`,
        requestFinanciacion
      )
        .then((response) => {
          this.confirmed = true;
          let respuestaData = response.data.message;
          const myToast = createToastInterface({timeout: false});
          if (respuestaData == 'OK 2171' || respuestaData == 'OK 02171') {
            myToast.success(this.$t("invoices.option2"));
          } else {
            myToast.success(this.$t("invoices.option1"));
          }
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    finalizar() {
      this.$router.push("/anticipo-facturas");
    },
    volver() {
      this.$router.push({
        path: "/anticipo-facturas",
        query: { goBack: true },
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style scoped>
.v-data-table__wrapper {
  overflow-x: auto;
  overflow-y: auto;
}
</style>
